import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class, fetch2 } from '../utils';
import icons from '../resources/icons';
import Searcher from './Searcher';
import DetailsHandlerDef from "../details/DetailsHandlerDef";
export default Class(Searcher, {
  spatialSuiteHost: null,
  layers: "",
  profile: "",
  profileQuery: "",
  buffer: "3",
  seek_all_themes: "false",
  initialize: function initialize(options) {
    if (options === undefined) throw "New Septima.Search.SqSearcher(options): Options missing.";
    options.usesGeoFunctions = true;
    if (!options.source) options.source = "WebGis";
    this.source = options.source;
    this.Searcher(options);
    this.ajaxURL = '';
    if (options.host) this.ajaxURL = options.host;
    this.layers = options.layers;
    this.profile = options.profile;
    this.profileQuery = options.profileQuery;
    this.buffer = 0;
    if (options.buffer) this.buffer = options.buffer;
    this.sessionId = "";
    this.applicationId = "";
    if (options.sessionId) this.sessionId = options.sessionId;else if (options.applicationId) this.applicationId = options.applicationId;
  },
  sq: function () {
    var _sq = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(query) {
      var _data, wkt, params, fetch2Use, fetchOptions, data, queryResult, results, geometries, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, result;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(this.sessionId === "")) {
                _context.next = 15;
                break;
              }

              if (!(this.applicationId === "")) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", this.createQueryResult());

            case 5:
              _context.prev = 5;
              _context.next = 8;
              return fetch2(this.ajaxURL + '/spatialmap?page=create-session&applicationid=' + this.applicationId + '&outputformat=json');

            case 8:
              _data = _context.sent;
              this.sessionId = _data.row[0].sessionid;
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](5);
              throw "SqSearcher (" + this.ajaxURL + ") failed: " + _context.t0;

            case 15:
              wkt = query.wkt;
              params = {
                wkt: wkt,
                page: "s4spatialquery-getresult",
                profile: this.profile,
                profilequery: this.profileQuery,
                distance: this.buffer,
                sessionid: this.sessionId,
                layers: this.layers,
                "cbinfo.output": 'json',
                outputformat: 'json'
              };
              fetchOptions = {
                data: params
              };

              if (this.ajaxURL === "") {
                fetch2Use = fetch2;
                fetchOptions.method = 'post';
                fetchOptions.credentials = "include";
              } else {
                fetch2Use = fetch2;
              }

              _context.next = 21;
              return fetch2Use(this.ajaxURL + '/spatialmap', fetchOptions);

            case 21:
              data = _context.sent;
              data.query = query;
              queryResult = this.transformSqResultToList(data);
              results = queryResult.getResults();

              if (!(results.length > 0)) {
                _context.next = 48;
                break;
              }

              _context.next = 28;
              return this.getGeometries();

            case 28:
              geometries = _context.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 32;

              for (_iterator = results[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                result = _step.value;
                result.geometry = geometries[this.getPcolId(result.data)];
              }

              _context.next = 40;
              break;

            case 36:
              _context.prev = 36;
              _context.t1 = _context["catch"](32);
              _didIteratorError = true;
              _iteratorError = _context.t1;

            case 40:
              _context.prev = 40;
              _context.prev = 41;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 43:
              _context.prev = 43;

              if (!_didIteratorError) {
                _context.next = 46;
                break;
              }

              throw _iteratorError;

            case 46:
              return _context.finish(43);

            case 47:
              return _context.finish(40);

            case 48:
              return _context.abrupt("return", queryResult);

            case 49:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[5, 12], [32, 36, 40, 48], [41,, 43, 47]]);
    }));

    function sq(_x) {
      return _sq.apply(this, arguments);
    }

    return sq;
  }(),
  transformSqResultToList: function transformSqResultToList(sqResult) {
    var queryResult = this.createQueryResult();

    try {
      //row[0].row[0].row er array af targets
      var targets = sqResult.row[0].row[0].row; //row[0].row[0].row[i].row er target
      //row[0].row[0].row[i].row[0] overskrift
      //row[0].row[0].row[i].row[10 + n].row featureN

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = targets[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var target = _step2.value;

          try {
            var properties = target.row;
            var title = properties[0].overskrift;

            for (var t = 10; t < properties.length; t++) {
              var feature = properties[t];
              var heading = this.getHeading(feature);

              if (heading !== null) {
                var result = queryResult.addResult(this.source, title, heading, title, null, feature);
                result.target = title;
                result.distance = 0;
                result.isComplete = true;
              }
            }
          } catch (e) {// catch all
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    } catch (e) {// catch all
    }

    return queryResult;
  },
  getHeading: function getHeading(feature) {
    if (typeof feature.row !== 'undefined') {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = feature.row[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var row = _step3.value;
          if (row.format == 'heading') return row.value;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }

    return null;
  },
  getPcolId: function getPcolId(feature) {
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = feature.row[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var row = _step4.value;
        if (row.format == 'org-pcolid') return row.value;
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    return "";
  },
  getGeometries: function () {
    var _getGeometries = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var params, fetch2Use, fetchOptions, data, geometries, targets, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, target, features, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, feature, wkt, pcolid;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params = {
                page: "s4spatialquery-getoutput",
                sessionid: this.sessionId
              };
              fetchOptions = {
                data: params
              };

              if (this.ajaxURL === "") {
                fetch2Use = fetch2;
                fetchOptions.method = 'post';
                fetchOptions.credentials = "include";
              } else {
                fetch2Use = fetch2;
              }

              _context2.next = 5;
              return fetch2Use(this.ajaxURL + '/spatialmap?cbinfo.output=json&outputformat=json', fetchOptions);

            case 5:
              data = _context2.sent;
              geometries = {};
              targets = data.row[0].row[0].row;
              _iteratorNormalCompletion5 = true;
              _didIteratorError5 = false;
              _iteratorError5 = undefined;
              _context2.prev = 11;
              _iterator5 = targets[Symbol.iterator]();

            case 13:
              if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                _context2.next = 39;
                break;
              }

              target = _step5.value;
              //row[0].row[0].row[i]
              features = target.row;

              if (!(typeof features !== 'undefined')) {
                _context2.next = 36;
                break;
              }

              _iteratorNormalCompletion6 = true;
              _didIteratorError6 = false;
              _iteratorError6 = undefined;
              _context2.prev = 20;

              for (_iterator6 = features[Symbol.iterator](); !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                feature = _step6.value;
                wkt = feature.shape_wkt;
                pcolid = feature._pcolid;
                geometries[pcolid] = this.translateWktToGeoJsonObject(wkt);
              }

              _context2.next = 28;
              break;

            case 24:
              _context2.prev = 24;
              _context2.t0 = _context2["catch"](20);
              _didIteratorError6 = true;
              _iteratorError6 = _context2.t0;

            case 28:
              _context2.prev = 28;
              _context2.prev = 29;

              if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                _iterator6.return();
              }

            case 31:
              _context2.prev = 31;

              if (!_didIteratorError6) {
                _context2.next = 34;
                break;
              }

              throw _iteratorError6;

            case 34:
              return _context2.finish(31);

            case 35:
              return _context2.finish(28);

            case 36:
              _iteratorNormalCompletion5 = true;
              _context2.next = 13;
              break;

            case 39:
              _context2.next = 45;
              break;

            case 41:
              _context2.prev = 41;
              _context2.t1 = _context2["catch"](11);
              _didIteratorError5 = true;
              _iteratorError5 = _context2.t1;

            case 45:
              _context2.prev = 45;
              _context2.prev = 46;

              if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                _iterator5.return();
              }

            case 48:
              _context2.prev = 48;

              if (!_didIteratorError5) {
                _context2.next = 51;
                break;
              }

              throw _iteratorError5;

            case 51:
              return _context2.finish(48);

            case 52:
              return _context2.finish(45);

            case 53:
              return _context2.abrupt("return", geometries);

            case 54:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[11, 41, 45, 53], [20, 24, 28, 36], [29,, 31, 35], [46,, 48, 52]]);
    }));

    function getGeometries() {
      return _getGeometries.apply(this, arguments);
    }

    return getGeometries;
  }(),
  hasDetails: function hasDetails(feature) {
    if (typeof feature.hasDetails === "undefined") {
      feature.hasDetails = false;
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = feature.row[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var row = _step7.value;

          if (row.format === '' && row.value && row.value !== '') {
            feature.hasDetails = true;
            return true;
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }
    } else {
      return feature.hasDetails;
    }
  },
  hasDetailHandlersForResult: function hasDetailHandlersForResult(result) {
    var feature = result.data;
    return this.hasDetails(feature);
  },
  getDetailHandlersForResult: function getDetailHandlersForResult(result) {
    var feature = result.data;
    var detailHandlerDefs = [];

    if (this.hasDetails(feature)) {
      var detailsHandler = function detailsHandler() {
        return new Promise(function (resolve) {
          var items = [];
          var _iteratorNormalCompletion8 = true;
          var _didIteratorError8 = false;
          var _iteratorError8 = undefined;

          try {
            for (var _iterator8 = feature.row[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
              var row = _step8.value;

              if (row.format === '' && row.value && row.value !== '') {
                var label = row.label;
                var value = row.value;
                items.push({
                  type: "labelvalue",
                  label: label,
                  value: value
                });
              }
            }
          } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
                _iterator8.return();
              }
            } finally {
              if (_didIteratorError8) {
                throw _iteratorError8;
              }
            }
          }

          resolve(items); //resolve(detailsContent.formatItems(items));
        });
      };

      var detailHandlerDef = new DetailsHandlerDef({
        "buttonText": "Attributter",
        "buttonImage": icons.details.moreHeader,
        "handler": detailsHandler,
        "more": true
      });
      detailHandlerDefs.push(detailHandlerDef);
    }

    return detailHandlerDefs;
  },
  getCustomButtonsForResult: function getCustomButtonsForResult(result) {
    var feature = result.data;
    var customButtonDef;
    var customButtonDefs = [];
    var _iteratorNormalCompletion9 = true;
    var _didIteratorError9 = false;
    var _iteratorError9 = undefined;

    try {
      var _loop = function _loop() {
        var row = _step9.value;

        if (row.format === 'hyperlink') {
          customButtonDef = {
            "buttonText": row.label,
            "buttonImage": icons.linksymbol,
            "callBack": function callBack() {
              window.open(row.value, "_blank");
            }
          };
          customButtonDefs.push(customButtonDef);
        } else if (row.format === 'javascriptlink') {
          customButtonDef = {
            "buttonText": row.label,
            "buttonImage": icons.linksymbol,
            "callBack": function callBack() {
              jQuery.globalEval(row.value);
            }
          };
          customButtonDefs.push(customButtonDef);
        }
      };

      for (var _iterator9 = feature.row[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
        _loop();
      }
    } catch (err) {
      _didIteratorError9 = true;
      _iteratorError9 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
          _iterator9.return();
        }
      } finally {
        if (_didIteratorError9) {
          throw _iteratorError9;
        }
      }
    }

    return customButtonDefs;
  },
  CLASS_NAME: 'Septima.Search.SqSearcher'
});